import { Outlet } from 'react-router-dom'

import { Body } from '../../body'
import { Footer } from '../../footer'
import { Header } from '../../header'

export const Layout = () => {
  return (
    <>
      {/* <title>calories</title> */}

      <Header />

      <Body>
        <Outlet />
      </Body>

      <Footer />
    </>
  )
}
